import React, { ChangeEventHandler, Dispatch, SetStateAction } from "react";

interface Props {
  value: number | string;
  setValue: Dispatch<SetStateAction<number | string>>;
  onChange: ChangeEventHandler<HTMLInputElement>;
  description: string;
  maxValue?: number;
  minValue: number;
}

const InputField = (props: Props) => {
  const { value, onChange, description, maxValue, setValue, minValue } = props;

  const checkMax = () => {
    if (maxValue) {
      if (value > maxValue) {
        setValue(maxValue);
      }
    } else {
      setValue(value);
    }
    if (value <= minValue) {
      setValue(minValue);
    }
  };

  return (
    <div className="">
      <div className="relative rounded-md shadow-sm end-0">
        <input
          type="text"
          name="value"
          id="value"
          className="block w-full rounded border-0 py-1.5 pl-3 pr-20 text-gray-900 ring-1 ring-inset ring-black placeholder:text-gray-400 focus:ring-1 focus:ring-inset sm:text-sm sm:leading-6 h-12"
          placeholder={value.toString()}
          value={value}
          onChange={onChange}
          onBlur={checkMax}
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-4">
          <span className="text-black sm:text-sm">{description}</span>
        </div>
      </div>
    </div>
  );
};
export default InputField;
